'use client';

import { trackSignUp } from '@/lib/analytics';
import { useEffect, useRef } from 'react';

export function SignupTracker() {
  const processedRef = useRef(false);

  useEffect(() => {
    // Check for our custom signup cookie
    const checkSignupCookie = () => {
      if (processedRef.current) return;

      const match = document.cookie.match(/(^| )zappingai_new_signup=([^;]+)/);
      // console.log('[Analytics] Checking for signup cookie:', match ? 'FOUND' : 'NOT FOUND');

      if (match && match[2] === 'true') {
        // Check if gtag is available - if not, wait for it
        if (typeof window.gtag !== 'function') {
          // console.log('[Analytics] Signup cookie found but gtag not ready, retrying...');
          return false; // Return false to indicate we should retry
        }

        trackSignUp('social_signup', { email: null });
        processedRef.current = true;

        // Clear the cookie so it doesn't fire again
        // Clear with and without domain to ensure it's removed
        document.cookie = 'zappingai_new_signup=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie =
          'zappingai_new_signup=; Path=/; Domain=; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        return true;
      }
      return false;
    };

    // Run immediately
    checkSignupCookie();

    // Check a few more times with delays in case cookie is set after initial render
    const intervals = [100, 300, 500, 1000, 2000, 3000];
    const timeouts = intervals.map((delay) =>
      setTimeout(() => {
        if (!processedRef.current) {
          checkSignupCookie();
        }
      }, delay)
    );

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, []); // Empty dependency array - run once on mount

  return null;
}
